import { HttpError } from '@/services/fintalk/api/types/errors/HttpError'
import { NetworkError } from '@/services/fintalk/api/types/errors/NetworkError'

export function shouldReportError(error: unknown): boolean {
  if (error instanceof NetworkError) {
    return false
  }

  if (error instanceof HttpError) {
    const statusCode = error.response?.statusCode

    return statusCode === undefined || statusCode >= 500
  }

  return true
}
